import { api } from '@/src/shared/lib/api'

export async function giftGet<ApiResponse>(showVip: boolean = false) {
  const url = api.appURL('gift')
  if (!showVip) url.searchParams.append('show_vip', '0')
  const response = await api.get<ApiResponse>(url, {})
  return api.parseRespone<ApiResponse>(response)
}
